export const FILTER_OPTIONS = [
  { id: "all", label: "Type of lessons" },
  { id: "online", label: "Online" },
  { id: "primary", label: "Primary" },
  { id: "senior", label: "Years 7-9" },
  { id: "budget", label: "Under AUD 20/hr" },
  { id: "fast", label: "Fast replies" },
];

export const TUTORS = [
  {
    id: "amelia-rose",
    name: "Amelia",
    location: "Melbourne, Australia",
    mode: "Face to face & online",
    rating: 5,
    reviews: 18,
    price: 58,
    badge: "1st lesson free",
    responseTime: "Quick to respond",
    responseStat: "Quick to respond",
    students: 26,
    years: ["Year 3", "Year 4", "Year 5", "Year 6"],
    level: "primary",
    description:
      "Warm, structured maths support for children who need confidence before class and calm guidance after school.",
    image: "https://i.pravatar.cc/900?img=32",
    topics: [
      "Numeracy foundations",
      "Homework help",
      "Confidence building",
      "Parent progress updates",
    ],
    heroText:
      "Need a calm, reliable maths tutor for upper-primary years? Amelia builds fluency, confidence and homework routines through patient one-to-one support that fits around school and family life.",
    lessonLocations: [
      "At your home in Melbourne and nearby suburbs",
      "Online lessons with guided whiteboard practice",
      "MathDingo-aligned follow-up tasks between sessions",
    ],
    about:
      "Amelia works closely with primary students who understand more when learning is broken into smaller, repeatable steps. Her sessions focus on building number confidence, showing clear methods, and helping children explain how they got an answer instead of guessing.",
    parentFit:
      "Best for families who want gentle accountability, clearer homework routines, and regular updates on what their child is improving each week.",
    supportIncludes: [
      "Weekly goal setting",
      "Fraction and multiplication fluency",
      "School homework check-ins",
      "Simple notes for parents after sessions",
    ],
    lessonAudience: "Primary School • Year 3-6",
    lessonLanguage: "English",
    lessonOverview: [
      "Lessons focus on the core numeracy skills children need to feel calm and capable in class. Amelia uses clear worked examples, quick fluency warm-ups and guided practice so students can build accuracy without feeling rushed.",
      "Each session is structured around one or two priority goals. That might be multiplication confidence, fraction understanding or getting more organised with weekly homework. Parents get simple updates so they know what was covered and what to keep practising at home.",
      "The aim is steady confidence, not pressure. Children leave with clearer methods, more consistent routines and support that fits naturally around their school week.",
    ],
    packPrices: ["5h: $275", "10h: $540"],
    onlineRate: "$58/h",
    freeLesson: "1st lesson free",
  },
  {
    id: "josh-li",
    name: "Josh",
    location: "Geelong, Australia",
    mode: "Online",
    rating: 4.9,
    reviews: 11,
    price: 54,
    badge: "Popular with parents",
    responseTime: "Quick to respond",
    responseStat: "Quick to respond",
    students: 19,
    years: ["Year 5", "Year 6", "Year 7"],
    level: "primary",
    description:
      "Patient tutor focused on helping students bridge gaps in fractions, decimals and weekly homework routines.",
    image: "https://i.pravatar.cc/900?img=12",
    topics: [
      "Fractions",
      "Decimals",
      "Transition to Year 7",
      "Homework structure",
    ],
    heroText:
      "Josh helps students who are close to understanding maths but still need guided repetition and a clearer system. His online lessons are practical, encouraging and ideal for children preparing for the jump into secondary maths.",
    lessonLocations: [
      "Online only across Australia",
      "Interactive screen-sharing and problem walkthroughs",
      "Short recap tasks to reinforce each session",
    ],
    about:
      "Josh specialises in the moments where confidence starts to wobble: fractions, decimals, percentages and multi-step questions. He slows the pace down, checks understanding carefully, and makes sure students leave each lesson knowing exactly what to practise next.",
    parentFit:
      "A strong fit for families looking for affordable, online-first support that helps a child stay on top of weekly school maths.",
    supportIncludes: [
      "Fraction and decimal revision",
      "Weekly homework planning",
      "Confidence before tests",
      "Transition support into Year 7",
    ],
    lessonAudience: "Upper Primary • Year 5-7",
    lessonLanguage: "English",
    lessonOverview: [
      "Josh runs practical online maths lessons for students who are starting to hit gaps in fractions, decimals and multi-step questions. Sessions are clear, paced carefully and built around the school topics a child is currently seeing each week.",
      "He uses screen-sharing, worked examples and short recap tasks so families get support that is flexible but still structured. This is especially useful for students heading into Year 7 who need stronger habits before secondary maths becomes more demanding.",
      "Parents can expect consistent online support, homework organisation help and a tutor who keeps maths feeling manageable instead of overwhelming.",
    ],
    packPrices: ["5h: $255", "10h: $500"],
    onlineRate: "$54/h",
    freeLesson: "No free lesson",
  },
  {
    id: "sofia-nguyen",
    name: "Sofia",
    location: "Ballarat, Australia",
    mode: "Online",
    rating: 5,
    reviews: 9,
    price: 67,
    badge: "Ambassador",
    responseTime: "Quick to respond",
    responseStat: "Quick to respond",
    students: 14,
    years: ["Year 7", "Year 8", "Year 9"],
    level: "senior",
    description:
      "Clear high-school maths coaching with step-by-step explanations that reduce stress before tests and assessments.",
    image: "https://i.pravatar.cc/900?img=5",
    topics: [
      "Algebra basics",
      "Problem solving",
      "Exam preparation",
      "Confidence for Year 7-9",
    ],
    heroText:
      "Sofia is a strong option for families who want a more structured secondary-style maths tutor. She combines clear method teaching with calm exam preparation so students stop freezing when questions become multi-step or unfamiliar.",
    lessonLocations: [
      "Online lessons available Australia-wide",
      "Live worked examples and annotated solutions",
      "Optional revision plans before school assessments",
    ],
    about:
      "Her tutoring focuses on making secondary maths feel predictable again. Students practise reading questions carefully, planning an approach, and working through algebra and number reasoning with a consistent structure they can reuse in class and tests.",
    parentFit:
      "Best for students who know content is getting harder and need explicit strategy, not just more worksheets.",
    supportIncludes: [
      "Algebra and reasoning practice",
      "Revision plans before tests",
      "Step-by-step worked solutions",
      "Support for anxious learners",
    ],
    lessonAudience: "High School • Year 7-9",
    lessonLanguage: "English",
    lessonOverview: [
      "Sofia teaches students who need more structure as maths becomes more abstract. Lessons cover algebra, reasoning, and test-style problem solving with a strong focus on reading questions properly and showing method clearly.",
      "Sessions are ideal for learners who know they understand parts of the work but freeze when they face longer, multi-step questions. Sofia slows the process down and gives students a repeatable system they can use during class and assessments.",
      "The result is a calmer approach to high-school maths, stronger revision habits and fewer last-minute panics before tests.",
    ],
    packPrices: ["5h: $320", "10h: $620"],
    onlineRate: "$67/h",
    freeLesson: "No free lesson",
  },
  {
    id: "benjamin-clark",
    name: "Benjamin",
    location: "Preston, Australia",
    mode: "Face to face & online",
    rating: 4.8,
    reviews: 7,
    price: 63,
    badge: "Exam prep",
    responseTime: "Quick to respond",
    responseStat: "Quick to respond",
    students: 17,
    years: ["Year 6", "Year 7", "Year 8"],
    level: "senior",
    description:
      "Supportive tutor for upper-primary and early-secondary students who need stronger reasoning and exam habits.",
    image: "https://i.pravatar.cc/900?img=14",
    topics: [
      "Reasoning skills",
      "Worded problems",
      "Exam habits",
      "Upper-primary extension",
    ],
    heroText:
      "Benjamin supports students who need more than content revision. His lessons focus on mathematical thinking, exam habits and clearer reasoning, especially for children moving from upper-primary into early secondary school.",
    lessonLocations: [
      "Face to face in Preston and surrounding suburbs",
      "Online lessons for flexible weekday support",
      "Travel available by arrangement for local families",
    ],
    about:
      "He works well with students who rush, lose marks on method, or struggle to unpack worded questions. Sessions are structured to improve how students think through a problem, explain working, and check their own answers before finishing.",
    parentFit:
      "A good choice for parents looking for a little more structure, challenge and exam-readiness without losing the personal one-to-one feel.",
    supportIncludes: [
      "Reasoning and multi-step questions",
      "Method marks and working out",
      "Upper-primary extension work",
      "Secondary transition support",
    ],
    lessonAudience: "Upper Primary • Early High School",
    lessonLanguage: "English",
    lessonOverview: [
      "Benjamin's lessons are designed for students who need stronger mathematical reasoning, not just more repetition. He helps children unpack worded problems, show working clearly and build the habits that matter for more advanced school maths.",
      "Sessions can be face to face or online and are especially useful for students moving from Year 6 into Year 7 or Year 8. The teaching is structured, practical and focused on helping students make fewer avoidable mistakes.",
      "Families can expect a balance of concept teaching, worked examples and exam-style support that builds confidence over time.",
    ],
    packPrices: ["5h: $300", "10h: $590"],
    onlineRate: "$63/h",
    freeLesson: "No free lesson",
  },
  {
    id: "liann-zhou",
    name: "Liann",
    location: "Carlton, Australia",
    mode: "Online",
    rating: 5,
    reviews: 14,
    price: 59,
    badge: "New families love this",
    responseTime: "Quick to respond",
    responseStat: "Quick to respond",
    students: 22,
    years: ["Year 2", "Year 3", "Year 4"],
    level: "primary",
    description:
      "Gentle foundational tutoring for younger learners, with visual practice and progress updates parents can follow.",
    image: "https://i.pravatar.cc/900?img=47",
    topics: [
      "Early numeracy",
      "Visual learning",
      "Confidence for younger learners",
      "Parent communication",
    ],
    heroText:
      "Liann is ideal for younger learners who need maths to feel safe, visual and encouraging. Her sessions turn early numeracy into manageable steps and help children build confidence before small gaps become bigger problems.",
    lessonLocations: [
      "Online lessons designed for younger children",
      "Visual teaching with simple guided practice",
      "Easy parent updates after each session",
    ],
    about:
      "She focuses on foundational number sense, early problem solving and confidence with school maths routines. Lessons are calm and interactive, with lots of examples, repetition and simple explanations that younger children can understand and remember.",
    parentFit:
      "Best for parents of Year 2-4 learners who want nurturing support, strong communication and steady progress without pressure.",
    supportIncludes: [
      "Early numeracy and place value",
      "Visual explanation strategies",
      "School homework support",
      "Parent-friendly progress notes",
    ],
    lessonAudience: "Primary School • Year 2-4",
    lessonLanguage: "English",
    lessonOverview: [
      "Liann creates calm, visual lessons for younger learners who need maths broken into simple, encouraging steps. Sessions focus on number sense, place value, early problem solving and confidence with day-to-day classwork.",
      "She uses repetition, examples and guided practice so children can feel successful without being overloaded. Parents also get clear updates about what their child understood well and which skills still need reinforcement.",
      "This style works well for families who want supportive foundational tutoring that builds confidence before bigger gaps appear later on.",
    ],
    packPrices: ["5h: $280", "10h: $550"],
    onlineRate: "$59/h",
    freeLesson: "1st lesson free",
  },
];

export const matchesSelectedFilter = (tutor, selectedFilter) => {
  switch (selectedFilter) {
    case "online":
      return tutor.mode.toLowerCase().includes("online");
    case "primary":
      return tutor.level === "primary";
    case "senior":
      return tutor.level === "senior";
    case "budget":
      return tutor.price < 20;
    case "fast":
      return tutor.responseTime.toLowerCase().includes("quick to respond");
    default:
      return true;
  }
};

export const getTutorById = (tutorId) =>
  TUTORS.find((tutor) => tutor.id === tutorId) || null;
